<template>
  <div class="wrapper mt-10" style="margin-bottom: 75px !important">
    <div class="wrapper-login-box">
      <div class="my-5">
        <div class="mb-3">
          <h4>SET Chatbot</h4>
          <div>ถามตอบเรื่องการลงทุน 24 ชั่วโมง</div>
        </div>
        <v-btn
          style="width: 100%; border-radius: 30px; color: black; font-weight: bold"
          color="primary"
          @click="$emit('selectType', 'bot')"
          >SET Chatbot Click</v-btn
        >
      </div>
      <div class="my-5">
        <div class="mb-3">
          <h4 style="text-align: center">สอบถามเจ้าหน้าที่ในวันทำการ</h4>
          <div style="text-align: center">8:00-18:00 น. หรือฝากข้อความ</div>
        </div>
        <v-btn
          style="width: 100%; border-radius: 30px; color: black; font-weight: bold"
          @click="$emit('selectType', 'admin')"
          color="primary"
          >SET LiveChat Click</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['setting'])
  },
  beforeCreate() {
    this.$store.state.bgcolor = '#efefef'
  },
  beforeDestroy() {
    this.$store.state.bgcolor = 'white'
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>
